import { Card, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import React, { useState } from "react";
import ChartBloodPressure from "./BloodPressureChart";
import {
  BLOOD_PRESSURE_CHART,
  CENTRAL_SYSTOLIC_PRESSURE_CHART,
  PULSE_PRESSURE_AMPLIFICATION_CHART,
  PULSE_PRESSURE_CHART,
} from "./constants";
import TabPanel from "components/Users/TabPanel";

const tabs = [
  { index: 0, label: "Brachial Blood Pressure" },
  { index: 1, label: "Central Pulse Pressure" },
  { index: 2, label: "Pulse Pressure Amplification" },
  { index: 3, label: "Central Systolic Pressure" },
];
export default function BloodPressureMetricsCard({ measures }) {
  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (_, newValue) => setTabIndex(newValue);
  return (
    <Card
      sx={{
        padding: "12px",
        borderRadius: "11px",
        border: "1px solid #E6E6EC",
        boxShadow: "none",
      }}
    >
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        sx={{
          minHeight: 32,
          width: { xs: "auto", sm: "fit-content", lg: "fit-content" },
        }}
      >
        {tabs.map((tab) => (
          <Tab
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              minHeight: 30,
              padding: 1,
              textTransform: "capitalize",
              color: "#00000099",
            }}
            key={tab.index}
            label={tab.label}
          />
        ))}
      </Tabs>
      <TabPanel value={tabIndex} index={0}>
        <ChartBloodPressure measures={measures} graphs={BLOOD_PRESSURE_CHART} />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <ChartBloodPressure measures={measures} graphs={PULSE_PRESSURE_CHART} />
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <ChartBloodPressure
          measures={measures}
          graphs={PULSE_PRESSURE_AMPLIFICATION_CHART}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={3}>
        <ChartBloodPressure
          measures={measures}
          graphs={CENTRAL_SYSTOLIC_PRESSURE_CHART}
        />
      </TabPanel>
    </Card>
  );
}

BloodPressureMetricsCard.propTypes = {
  measures: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ),
};

BloodPressureMetricsCard.defaultProps = {
  measures: [],
};
